import React from 'react';
import './App.css';

/**
 * Pick a maintenance_staff member and confirm assignment to a request.
 */
export default function MaintenanceAssignStaffModal({
  open,
  title,
  subtitle,
  staff,
  staffLoading,
  saving,
  onClose,
  onConfirm,
}) {
  const [staffId, setStaffId] = React.useState('');

  React.useEffect(() => {
    if (open) setStaffId('');
  }, [open]);

  if (!open) return null;

  return (
    <div className="properties-modal-root" role="presentation" onClick={onClose}>
      <div
        className="properties-modal-panel maint-assign-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="maint-assign-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="properties-modal-header">
          <h2 id="maint-assign-title" className="properties-modal-title">
            {title}
          </h2>
          <button type="button" className="properties-modal-close" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="properties-modal-body">
          {subtitle ? <p className="tenant-card-sub" style={{ marginBottom: 12 }}>{subtitle}</p> : null}
          {staffLoading ? (
            <p className="properties-list-empty">Loading team…</p>
          ) : staff.length === 0 ? (
            <p className="properties-list-empty">
              No staff members yet. Add people under <strong>Staff</strong> first (with email and password so they
              can sign in).
            </p>
          ) : (
            <>
              <div className="field-wrapper">
                <label className="field-label" htmlFor="maint-assign-staff">
                  Assign to
                </label>
                <div className="input-shell">
                  <select
                    id="maint-assign-staff"
                    className="input-element"
                    value={staffId}
                    onChange={(e) => setStaffId(e.target.value)}
                  >
                    <option value="">Select a team member…</option>
                    {staff.map((s) => (
                      <option key={s.id} value={s.id}>
                        {(s.full_name || '—').trim()}
                        {s.role ? ` — ${s.role}` : ''}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="properties-modal-footer" style={{ marginTop: 16 }}>
                <button type="button" className="btn-ghost" onClick={onClose}>
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  disabled={!staffId || saving}
                  onClick={() => onConfirm(staffId)}
                >
                  {saving ? 'Saving…' : 'Assign task'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
